import { render, staticRenderFns } from "./TabletSvg.vue?vue&type=template&id=1ce574fc&scoped=true&"
import script from "./TabletSvg.vue?vue&type=script&lang=js&"
export * from "./TabletSvg.vue?vue&type=script&lang=js&"
import style0 from "./TabletSvg.vue?vue&type=style&index=0&id=1ce574fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce574fc",
  null
  
)

export default component.exports